export default {
  title: '客戶關係管理',
  header: '客戶關係管理',
  lead: {
    header: '聯絡',
    leadList: '名單',
    keywords: '關鍵字',
    create: {
      header: '新增聯絡',
      type: '種類',
      dateOfContact: '接觸日期',
      name: '名稱',
      phoneNumber: '電話號碼',
      gender: '性別',
      identityCardNo: '身分証號碼',
      status: '狀態',
      remarks: '備註',
      activityLog: '活動記錄',
      header: '新增聯絡',
      level: '層級',
      createTime: '新增時候',
      updateTime: '最後更新',
      confirmation: '確認要新增或編輯?',
      success: '新增或編輯成功',
      leadLevel: '層級',

    },
    convertToCustomer: '由聯絡轉為客戶',
    page: '頁數',
    total: '總數',
    items: '項目',
    search: '搜尋',
    dateFrom: '由',
    dateTo: '至',
    clear: '清除過濾器'
  },
  edit: '編輯',
  customer: {
    header: '客戶',
    customerList: '列表',
    success: '操作成功',
    doubleClick: '連按兩次點選一個聯絡',
    importFromLead: '由連絡匯入',
    customerName: '客戶名稱',
    search: '搜尋客戶',
    currentAgent: '負責顧問',
    edit: '編輯',
    create: {
      header: '新增客戶',

      customerType: '客戶類別',
      customerCode: '客戶編號',
      englishFirstname: 'English Surname',
      englishLastname: 'English Other Name',
      chineseLastname: '中文姓',
      chineseFirstname: '中文名字',
      englishCompanyName: 'English Company Name',
      chineseCompanyName: '中文公司名',
      identityCardNo: '身分証號碼',
      brNo: '商業登記証號碼',
      gender: '姓別',
      dateOfBirth: '出生日期',
      idType: '身分証類別',
      maritalStatus: '婚姻狀況',
      contactType: '聯絡種類',
      defaultAddress: '預設地址',

      smoker: '吸煙者',
      education: '教育',
      occupation: '職業',
      nameOfEmployer: '僱主名稱',
      lengthOfServices: '服務年資',

      telephoneMobile: '手機號碼',
      telephoneHome: '屋企',
      telephoneOffice: '辦公室',
      fax: '傳真',
      email: '電郵',
      chineseResidentialAddress: '中文住址',
      englishResidentialAddress: 'Residential Address',
      chineseCorrespondenceAddress: '中文通報地址',
      englishCorrespondenceAddress: 'English',
      correspondenceAddressLeaveBlank: '如通訊地址跟住址一樣則此項留空',
      companyCorrespondenceAddressLeaveBlank: '如通訊地址跟公司地址一樣則此項留空',
      chineseCompanyAddress: '公司地址',
      englishCompanyAddress: 'Company Address',

      residentialAddress: '住址',
      correspondenceAddress: '通訊地址',
      companyAddress: '公司地址',

      personalHeader: '用戶資料',
      userEmail: '用戶電郵',
      language: '語言',
      marketingOptOut: '拒絕銷售名單',

      generalHeader: '一般資料',
      contactHeader: '聯絡資料',
      customerHeader: '客戶資料',

      confirmation: '確認新增客戶?',
      header: '新增客戶',

      success: '新增或編輯成功'
    },
    lifePolicyCount: '人壽保單數量',
    generalPolicyCount: '一般保險單數量',
    list: {
      lifePolicyCount: '{count} 人壽保單',
      generalPolicyCount: '{count} 一般保險單'
    },
  },
  calendar: {

    header: '行事曆',
    indicator: {
      birthday: '生日',
      life: '人壽保單',
      gi: '一般保險單',
      serviceRequest: '服務申請',
      renewal: '續保'
    },
  },
}



// WEBPACK FOOTER //
// ./src/Crm/langs/zh_hk/index.js